import React from 'react';
import Gauge from 'react-gauge-chart';


const GaugeChart = (props) => {

    const average = (array) => array.reduce((a, b) => a + b) / array.length

    return (
        <Gauge id="gaugechart" percent={average(props.all) * 20 / 100} needleColor="black" textColor="black" colors={['red', 'yellow', 'green']}/>
    )
};

export default GaugeChart;